// Brands show 頁面的 stores 篩選和分頁
document.addEventListener('DOMContentLoaded', function() {
  const storesContainer = document.getElementById('stores-container');
  const regionLinks = document.querySelectorAll('.stores-cate .page-group-link');

  if (!storesContainer || regionLinks.length === 0) return;

  // 處理區域按鈕點擊
  regionLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      // 更新按鈕 active 狀態
      regionLinks.forEach(l => l.classList.remove('is-active'));
      this.classList.add('is-active');

      // 載入 stores
      const url = this.getAttribute('href');
      loadStores(url);
    });
  });

  // 處理分頁連結點擊（使用事件委派）
  storesContainer.addEventListener('click', function(e) {
    const paginationLink = e.target.closest('.pagy-bootstrap-nav a');
    if (paginationLink && paginationLink.href) {
      e.preventDefault();
      loadStores(paginationLink.href);
    }
  });

  // AJAX 載入 stores
  function loadStores(url) {
    // 顯示載入狀態（可選）
    storesContainer.style.opacity = '0.5';

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
      .then(response => response.text())
      .then(html => {
        storesContainer.innerHTML = html;
        storesContainer.style.opacity = '1';

        // 滾動到 stores 區域（可選）
        storesContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(error => {
        console.error('Error loading stores:', error);
        storesContainer.style.opacity = '1';
      });
  }
});
